import { render, staticRenderFns } from "./CategorieTable.vue?vue&type=template&id=3630be78&scoped=true"
import script from "./CategorieTable.vue?vue&type=script&lang=js"
export * from "./CategorieTable.vue?vue&type=script&lang=js"
import style0 from "./CategorieTable.vue?vue&type=style&index=0&id=3630be78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630be78",
  null
  
)

export default component.exports